import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { QRCodeSVG } from "qrcode.react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import { getOutletDetails } from "actions/dashboardActions";
import { PUBLIC_REVIEW_URL } from "config";
import "assets/css/styles.css";

const getOutletName = (outlet) => outlet?.name?.trim() || "";

const getOutletId = (outlet, userInfo) => {
  const fromOutlet = outlet?.id;
  if (fromOutlet != null && fromOutlet !== "") {
    return String(fromOutlet);
  }

  const fromUser = userInfo?.user?.erp_user?.outlet;
  return fromUser != null ? String(fromUser) : "";
};

const buildReviewUrl = (outletId) => {
  if (!outletId) return "";
  const baseUrl = PUBLIC_REVIEW_URL.replace(/\/$/, "");
  return `${baseUrl}/${outletId}`;
};

const copyToClipboard = async (text) => {
  if (!text) return false;

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  document.body.removeChild(textarea);
  return copied;
};

const QrOutletView = () => {
  const dispatch = useDispatch();
  const { outlet } = useSelector((state) => state.outletDetail);
  const { userInfo } = useSelector((state) => state.userLogin);
  const outletName = getOutletName(outlet);
  const outletId = getOutletId(outlet, userInfo);
  const reviewUrl = buildReviewUrl(outletId);
  const [linkCopied, setLinkCopied] = useState(false);

  useEffect(() => {
    if (!outlet) {
      dispatch(getOutletDetails());
    }
  }, [dispatch, outlet]);

  const handleCopyReviewUrl = async () => {
    if (!reviewUrl) return;

    try {
      const success = await copyToClipboard(reviewUrl);
      if (!success) return;
      setLinkCopied(true);
      window.setTimeout(() => setLinkCopied(false), 2000);
    } catch (error) {
      // Ignore clipboard errors silently.
    }
  };

  return (
    <div className="content">
      <Row>
        <Col md="8">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Outlet Review</CardTitle>
              <p className="category">
                Share a review link and QR code for customers to rate this outlet.
              </p>
            </CardHeader>
            <CardBody>
              <div className="ncell-qr-panel">
                {outletId ? (
                  <>
                    <p className="text-dark font-weight-bold mb-1">
                      {outletName || `Outlet ${outletId}`}
                    </p>
                    <p className="text-muted small mb-4">
                      Customers can scan this QR to leave feedback for this outlet.
                    </p>
                    <div className="ncell-qr-code mb-4">
                      <QRCodeSVG value={reviewUrl} size={220} level="M" />
                    </div>
                    <p className="ncell-qr-url mb-3">{reviewUrl}</p>
                    <Button
                      type="button"
                      className="button-light-gray"
                      onClick={handleCopyReviewUrl}
                    >
                      {linkCopied ? "Copied!" : "Copy Link"}
                    </Button>
                  </>
                ) : (
                  <p className="text-muted mb-0">
                    Outlet details are loading. Please try again in a moment.
                  </p>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default QrOutletView;
